export default "__VITE_ASSET__Dps4nPuz__"